import { COAL_LOADING_VIEW, COAL_LOADING_EDIT } from '@/fixtures'

export default {
  path: 'bup-coal-loading',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Coal Loading',
      component: () => import('@/views/menus/CoalLoading/Index'),
      meta: {
        permission: COAL_LOADING_VIEW
      }
    },
    {
      path: ':id/detail',
      name: 'Detail Coal Loading',
      component: () => import('@/views/menus/CoalLoading/Detail'),
      meta: {
        permission: COAL_LOADING_VIEW,
        isEdit: false
      }
    },
    {
      path: ':id/edit',
      name: 'Edit Coal Loading',
      component: () => import('@/views/menus/CoalLoading/Detail'),
      meta: {
        permission: COAL_LOADING_EDIT,
        isEdit: true
      }
    }
  ]
}
